import React, { useContext } from "react";
import { Button } from "reactstrap";
import { AuthContext } from "../context/AuthContext";
import { SUPPORT_TICKET_URL, SUPPORT_PLATFORM } from "../constants";

// Botón "Reportar un problema" del puente de incidencias PSI (helpdesk externo).
// Abre el formulario de reporte en una pestaña nueva, prellenado con los datos
// de sesión del usuario. `platform` identifica el proyecto ante el helpdesk y
// es el único dato de este componente que difiere entre JEDI2 / FastFleet / Propex.
function getMainOrgUnitRole(auth) {
  const roles = auth?.user?.organizationalUnitRoles || [];
  return roles.find((r) => r.mainRole) || roles[0];
}

function buildReportUrl(auth) {
  const user = auth?.user?.user;
  const name = [user?.firstName, user?.lastName].filter(Boolean).join(" ");
  const mainRole = getMainOrgUnitRole(auth);

  const params = new URLSearchParams({ platform: SUPPORT_PLATFORM });
  if (name) params.set("name", name);
  if (auth?.user?.email) params.set("email", auth.user.email);
  if (mainRole?.organizationalUnit?.name) {
    params.set("agency", mainRole.organizationalUnit.name);
  }
  if (mainRole?.role?.name) params.set("role", mainRole.role.name);

  return `${SUPPORT_TICKET_URL}?${params.toString()}`;
}

export function ReportProblemButton(props) {
  const auth = useContext(AuthContext);

  return (
    <Button
      color="info"
      onClick={() => {
        window.open(buildReportUrl(auth), "_blank", "noopener,noreferrer");
      }}
      {...props}
    >
      Crear Ticket
    </Button>
  );
}

export default ReportProblemButton;